
const ScrollStyles = ({theme}) => {
    const isDark = theme.White !== "#FFFFFF";

    const scrollbarColor = isDark ? theme.Checo : theme.Ey;
    const arrowColor = isDark ? theme.Black : theme.THREEB;
    const trackColor = isDark ? theme.Alfalfa : theme.White;
    return (
        <style>
            {`
                ::-webkit-scrollbar { /*Define the size of the scrollbar*/
                    width: 10px;
                    height: 10px;
                    background-color: ${scrollbarColor}  /* Background color */
                }

                ::-webkit-scrollbar-thumb {
                    background-color: ${theme.Audi};   /* This color works for both light and dark mode */
                    border-radius: 5px;
                }

                ::-webkit-scrollbar-thumb:hover {
                    background-color: ${theme.Magenta};
                }
                
                ::-webkit-scrollbar-button {
                    display: block;
                    background-repeat: no-repeat;
                    background-size: 30px; /* Arrow size */
                    background-position: center;
                    background-color: ${trackColor};
                   
                }

                ::-webkit-scrollbar-button:start:increment,
                ::-webkit-scrollbar-button:end:decrement {  /* Render one arrow per side */
                    display: none;
                }

                /* ---------------- Arrows ---------------- */
                ::-webkit-scrollbar-button:vertical:start:decrement {
                    display: block;
                    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='${encodeURIComponent(arrowColor)}'><path d='M7 14l5-5 5 5H7z'/></svg>");
                }

                ::-webkit-scrollbar-button:vertical:end:increment {
                    display: block;
                    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='${encodeURIComponent(arrowColor)}'><path d='M7 10l5 5 5-5H7z'/></svg>");
                }

                ::-webkit-scrollbar-button:horizontal:start:decrement {
                    display: block;
                    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='${encodeURIComponent(arrowColor)}'><path d='M14 7l-5 5 5 5V7z'/></svg>");
                }

                ::-webkit-scrollbar-button:horizontal:end:increment {
                    display: block;
                    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='${encodeURIComponent(arrowColor)}'><path d='M10 17l5-5-5-5v10z'/></svg>");
                }
            `}
        </style>
    )
}

export default ScrollStyles